import React, { useState } from 'react';
import { Text } from 'src/common-ui';
import { FormikLayout } from './FormikLayout';
import { Footer } from './Footer';
import Ensemble from '../svg/Ensemble.svg';
import { ButtonShare } from './ButtonShare';

type ShareLinkProps = {
  title: string;
  info: string | React.ReactNode;
  shareURL: string;
  onSubmit: () => void;
};

export function ShareLinkComponent({ title, info, shareURL, onSubmit }: ShareLinkProps) {
  const [copied, setCopied] = useState(false);

  return (
    <FormikLayout initialValues={{}} onSubmit={onSubmit} style={{ paddingBottom: '120px' }}>
      <img src={Ensemble} alt="share" width="40%" style={{ marginTop: '15px' }} />

      <Text margin="25px 0" fontWeigth="bold" fontSize="22px">
        {title}
      </Text>

      <Text textAlign="center" style={{ width: '70%', marginBottom: '20px' }}>
        {info}
      </Text>

      <ButtonShare shareURL={shareURL} style={{ width: '70%', textAlign: 'center' }} onCopy={() => setCopied(true)} data-cy="share-link" />

      <Footer type="submit" disabled={!copied} title="Payer ma part" data-cy="btn-paid" />
    </FormikLayout>
  );
}
